t = require('app/scripts/views/internal/teacup-with-helpers')('saved_search')

module.exports = ->
  t.a '.saved-search-item.js-saved-search-name', { href: '#' }, ->

    t.span '.saved-search-item-name', ->
      t.text t.mustacheVar('name')

    t.text ' '

    t.span '.saved-search-query.quiet.js-saved-search-query', ->
      t.text t.mustacheVar('query')

  t.mustacheBlock 'allowDelete', ->

    t.a '.saved-search-delete.dark-hover.quiet.js-delete-saved-search', { href: '#' }, ->
      t.icon 'close'

    t.span '.saved-search-delete-menu.quiet.hide.js-delete-saved-search-menu', ->
      t.format 'are-you-sure-you-want-to-delete'
      t.a '.saved-search-delete-menu-item.js-delete-saved-search-confirm', { href: '#' }, ->
        t.format 'yes-delete'
      t.a '.saved-search-delete-menu-item.js-delete-saved-search-cancel', { href: '#' }, ->
        t.format 'no-keep-this'

